<div
  id="sidebar-toggle-wrapper"
  (click)="toggleSidebar()"
  [ngClass]="{ collapsed: isCollapsed }"
>
  <i
    class="chevron icon"
    [ngClass]="{ left: !isCollapsed, right: isCollapsed }"
  ></i>
</div>

<div class="slide">
  @if (routeName === 'client') {
  <app-client-sidebar></app-client-sidebar>
  } @if (routeName === 'population') {
  <app-population-sidebar></app-population-sidebar>
  } @if (routeName === 'tax-return' || routeName === 'project-form') {
  <app-tax-return-sidebar
    (collapseSidebar)="toggleSidebar($event)"
  ></app-tax-return-sidebar>
  } @if (routeName === 'population-rules') {
  <app-client-rules-sidebar></app-client-rules-sidebar>
  }
</div>
